import { render, staticRenderFns } from "./TraitFields.vue?vue&type=template&id=78e62ece"
import script from "./TraitFields.vue?vue&type=script&lang=js"
export * from "./TraitFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports